import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
urltoken: any;
  constructor(private commonService: CommonService, private session: SessionStorageService,) { }

  ngOnInit() {
    this.urltoken = this.session.retrieve('token');
  }

  logout(){
    this.commonService.logout();
  }
}
